import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const miniTestimonials = [{
  initials: 'MG',
  quote: 'Organicé todo el año en una tarde',
  name: 'Mariela G.',
  location: 'Córdoba',
  level: 'Secundaria'
}, {
  initials: 'LP',
  quote: 'Mis clases de secundaria por fin enganchan',
  name: 'Laura P.',
  location: 'Rosario',
  level: 'Secundaria'
}, {
  initials: 'RM',
  quote: 'Nunca más improvisé una clase',
  name: 'Roberto M.',
  location: 'Buenos Aires',
  level: 'Secundaria'
}];
export function SocialProof() {
  return <section className="py-16 bg-primary-dark" data-id="element-172">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        {/* Stats Grid */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="grid grid-cols-2 gap-8 mb-12" data-id="element-174">
          {/* +2000 docentes */}
          <div className="text-center" data-id="element-175">
            <p className="text-4xl md:text-5xl font-extrabold text-accent tracking-tight" data-id="element-176">
              +2.000
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-177">docentes confían</p>
          </div>

          {/* 12 Tomos */}
          <div className="text-center" data-id="element-178">
            <p className="text-4xl md:text-5xl font-extrabold text-white tracking-tight" data-id="element-179">
              8
            </p>
            <p className="text-gray-400 text-sm mt-1" data-id="element-180">
              Tomos completamente listos
            </p>
          </div>

          {/* 4.9/5 */}
          <div className="text-center" data-id="element-181">
            <p className="text-4xl md:text-5xl font-extrabold text-accent tracking-tight" data-id="element-182">
              4.9/5
            </p>
            <p className="text-gray-400 text-sm mt-1 flex items-center justify-center gap-1" data-id="element-183">
              calificación{' '}
              <StarIcon className="w-4 h-4 fill-accent text-accent" data-id="element-184" />
            </p>
          </div>

          {/* Todo el país */}
          <div className="text-center" data-id="element-185">
            <p className="text-3xl md:text-4xl mb-1" data-id="element-186">🇦🇷</p>
            <p className="text-gray-400 text-[12px]" data-id="element-187">
              Todo el país — secundaria
            </p>
          </div>
        </motion.div>

        {/* Mini Testimonials */}
        <div className="space-y-4" data-id="element-188">
          {miniTestimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-primary/60 border border-primary-light/30 rounded-2xl p-5" data-id="element-189">
              <div className="flex items-start gap-4" data-id="element-190">
                {/* Avatar */}
                <div className="w-11 h-11 rounded-full bg-accent/20 text-accent font-bold flex items-center justify-center text-sm shrink-0" data-id="element-191">
                  {testimonial.initials}
                </div>

                <div className="flex-1 min-w-0" data-id="element-192">
                  {/* Stars */}
                  <div className="flex gap-0.5 mb-2" data-id="element-193">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-accent text-accent" data-id="element-194" />)}
                  </div>

                  {/* Quote */}
                  <p className="text-white font-medium text-sm md:text-base mb-1" data-id="element-195">
                    "{testimonial.quote}"
                  </p>

                  {/* Attribution */}
                  <p className="text-gray-500 text-xs" data-id="element-196">
                    — {testimonial.name}, {testimonial.location} |{' '}
                    {testimonial.level}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}